import { render, staticRenderFns } from "./dept-choose.vue?vue&type=template&id=5b1367f2&"
import script from "./dept-choose.vue?vue&type=script&lang=js&"
export * from "./dept-choose.vue?vue&type=script&lang=js&"
import style0 from "./dept-choose.vue?vue&type=style&index=0&id=5b1367f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports